import { render, staticRenderFns } from "./ShippingRecord.html?vue&type=template&id=5b071e92&scoped=true&external"
import script from "./ShippingRecord.ts?vue&type=script&lang=ts&external"
export * from "./ShippingRecord.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingRecord.css?vue&type=style&index=0&id=5b071e92&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b071e92",
  null
  
)

export default component.exports